declare global {
  interface Window { dataLayer: unknown[]; gtag?: (...args: unknown[]) => void }
}

// Stored record: decision, when, notice version, and which choices were shown.
export const STORAGE_KEY = "cookie_consent_v1";
export const NOTICE_VERSION = "2026-10-14 (Datenschutz v2.8, Abschnitt 12)";
export const OPEN_SETTINGS_EVENT = "open-cookie-settings";

export type ConsentDecision = "granted" | "denied";
export interface ConsentRecord {
  decision: ConsentDecision;
  decidedAt: string;
  noticeVersion: string;
  purposes: string[];
  recipients: string[];
  country?: string;
}

const CONSENT_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO','GB','CH','CA'];
let region: Promise<{ required: boolean; country?: string }> | undefined;

export function lookupRegion() {
  return (region ??= (async () => {
    try {
      const res = await fetch("/cdn-cgi/trace", { signal: AbortSignal.timeout(2000) });
      if (!res.ok) return { required: true };
      const country = (await res.text()).match(/^loc=([A-Z0-9]{2})$/m)?.[1];
      if (!country || country === "XX" || country === "T1") return { required: true, country };
      return { required: CONSENT_COUNTRIES.includes(country), country };
    } catch {
      return { required: true };
    }
  })());
}

export function readConsent(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const rec = raw ? JSON.parse(raw) : null;
    return rec && (rec.decision === "granted" || rec.decision === "denied") ? rec : null;
  } catch {
    return null;
  }
}

export function applyConsent(decision: ConsentDecision) {
  window.dataLayer = window.dataLayer || [];
  const gtag = window.gtag || function (..._args: unknown[]) { // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments); };
  if (decision === "denied") gtag("set", "user_data", null);
  gtag("consent", "update", {
    ad_storage: decision,
    ad_user_data: decision,
    ad_personalization: decision,
    analytics_storage: decision,
  });
}

export async function saveConsent(decision: ConsentDecision) {
  const { country } = await lookupRegion();
  const rec: ConsentRecord = {
    decision,
    decidedAt: new Date().toISOString(),
    noticeVersion: NOTICE_VERSION,
    purposes: ["analytics (Google Analytics 4)", "advertising measurement (Google Ads)"],
    recipients: ["Google Ireland Ltd.", "Google LLC (USA)"],
    country,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(rec));
  applyConsent(decision);
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}
